// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * The primereact[.min].css has been deprecated. In order not to break existing projects, it is currently included in the build as an empty file.
 */`, "",{"version":3,"sources":["webpack://./node_modules/primereact/resources/primereact.min.css"],"names":[],"mappings":"AAAA;;EAEE","sourcesContent":["/**\n * The primereact[.min].css has been deprecated. In order not to break existing projects, it is currently included in the build as an empty file.\n */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
